angular.module('lead', ['core', 'lead.activity', 'clients.finder', 'lead-buffer', 'lead-bant'])
    .constant('LeadReferrerTypes', Object.freeze([
        Object.freeze({
            value: 'REFERRER',
            default: true,
            fileRequired: true
        }),
        Object.freeze({
            value: 'INTERMEDIARY',
            fileRequired: false
        })
    ]))
    .factory('Lead', function ($resource) {
        return $resource('/crm/api/lead/:id', {id: "@id"}, {
            find: {method: 'GET', isArray: true},
            list: {method: 'GET', isArray: true},
            get: {method: 'GET'},
            table: {method: 'GET', isArray: false, url: '/crm/api/lead/table'},
            relatedByContact: {method: 'GET', isArray: false, url: '/crm/api/lead/related-by-contact'},
            duplicateSuggestion: {method: 'GET', url: '/crm/api/lead/:id/duplicate-suggestion'},
            managerSuggestion: {method: 'GET', url: '/crm/api/lead/manager-suggestion'},
            managerCandidates: {method: 'GET', isArray: true, url: '/crm/api/lead/manager-candidates'},
            sourceSnapshots: {method: 'GET', isArray: true, url: '/crm/api/lead/:id/source-snapshots'},
            tableStatistics: {method: 'GET', isArray: false, url: '/crm/api/lead/table-statistics'},
            autocomplete: {method: 'GET', isArray: true, url: '/crm/api/lead/autocomplete'},
            summarizeSourceMessage: {method: 'POST', url: '/crm/api/lead/summarize-source-message'},
            createAutomatic: {method: 'POST', url: '/crm/api/lead/automatic'},
            update: {method: 'PUT'},
            completeManualData: {method: 'PUT', url: '/crm/api/lead/:id/manual-completion'},
            markDuplicate: {method: 'POST', url: '/crm/api/lead/:id/mark-duplicate'},
            managerChange: {method: 'POST', url: '/crm/api/lead/:id/manager-change'},
            smsUnlock: {method: 'POST', url: '/crm/api/lead/:id/sms-unlock'},
            smsLock: {method: 'POST', url: '/crm/api/lead/:id/sms-lock'},
            remove: {method: 'DELETE'}
        });
    })
    .component('leadSourceListCard', {
        bindings: {
            lead: '<'
        },
        templateUrl: 'app/lead/source-list-card.html',
        controller: function () {
            this.title = () => this.lead?.sourceName || this.lead?.sourcePhone || this.lead?.sourceEmail || 'Dane leada';
            this.hasContact = () => !!(this.lead?.sourcePhone || this.lead?.sourceEmail);
        }
    })
    .component('leadNextContact', {
        bindings: {
            nextContact: '<',
            layout: '@?',
            separator: '@?',
            dateClass: '@?',
            typeClass: '@?',
            typeMode: '@?'
        },
        template: `
            <span class="lead-next-contact" ng-if="$ctrl.nextContact">
                <span class="lead-next-contact__date {{$ctrl.dateClass}}"
                      ng-class="{'lead-next-contact__date--due text-danger bold': $ctrl.isDue()}">{{$ctrl.nextContact.date | date: 'shortDate'}}</span>
                <span class="workflow-deadline-flame workflow-deadline-flame--large blinking"
                      ng-if="$ctrl.isOverdueMoreThanWeek()"
                      uib-tooltip="{{$ctrl.getOverdueTooltip()}}">🔥&nbsp;</span>
                <span ng-if="$ctrl.hasType()">
                    <br ng-if="$ctrl.isStacked()"/>
                    <span ng-if="$ctrl.separator">{{$ctrl.separator}}</span>
                    <span class="{{$ctrl.typeClass}}">
                        <document-type-label ng-if="$ctrl.typeMode !== 'name'" type="$ctrl.nextContact.type"></document-type-label>
                        <span ng-if="$ctrl.typeMode === 'name'">{{$ctrl.nextContact.type.name}}</span>
                    </span>
                </span>
            </span>
        `,
        controller: function () {
            this.currentTime = moment().startOf('day');
            this.toDateMoment = value => {
                if (angular.isArray(value)) {
                    return moment({
                        year: value[0],
                        month: value[1] - 1,
                        date: value[2]
                    });
                }

                return moment(value);
            };
            this.isDue = () => {
                if (!this.nextContact || !this.nextContact.date) {
                    return false;
                }

                let nextContactDate = this.toDateMoment(this.nextContact.date);
                return nextContactDate.isValid() && !nextContactDate.startOf('day').isAfter(this.currentTime);
            };
            this.getOverdueDays = () => {
                if (!this.nextContact || !this.nextContact.date) {
                    return null;
                }

                let nextContactDate = this.toDateMoment(this.nextContact.date);
                if (!nextContactDate.isValid()) {
                    return null;
                }

                return this.currentTime.diff(nextContactDate.startOf('day'), 'days');
            };
            this.isOverdueMoreThanWeek = () => {
                let overdueDays = this.getOverdueDays();
                return overdueDays != null && overdueDays > 7;
            };
            this.getOverdueTooltip = () => {
                let overdueDays = this.getOverdueDays();
                return overdueDays == null ? "Opóźniony kolejny kontakt" : "Kolejny kontakt opóźniony " + overdueDays + " dni";
            };
            this.hasType = () => this.nextContact && this.nextContact.type;
            this.isStacked = () => this.layout !== 'inline';
        }
    })
    .factory('LeadSalesManagerConfig', function ($resource) {
        return $resource('/crm/api/lead-sales-manager-config/:id', {id: '@id'}, {
            list: {method: 'GET', isArray: true},
            self: {method: 'GET', url: '/crm/api/lead-sales-manager-config/self'},
            save: {method: 'POST'},
            update: {method: 'PUT'},
            updateSelf: {method: 'PUT', url: '/crm/api/lead-sales-manager-config/self'},
            remove: {method: 'DELETE'}
        });
    })
    .factory('LeadIntegrationAutoImportConfig', function ($resource) {
        return $resource('/crm/api/lead-integration-auto-import-config/:id', {id: '@id'}, {
            list: {method: 'GET', isArray: true},
            update: {method: 'PUT'}
        });
    })
    .component('leadIntegrationAutoImportConfigList', {
        bindings: {
            items: '<'
        },
        templateUrl: 'app/lead/integration-auto-import-config-list.html',
        controller: function (toastr, modals) {
            const ctrl = this;

            ctrl.edit = item => {
                return modals.open('app/lead/integration-auto-import-config-edit-modal.html', 'LeadIntegrationAutoImportConfigEditController', angular.copy(item), {size: 'md'}, '$ctrl')
                    .then(saved => {
                        const index = ctrl.items.findIndex(existing => existing.id === saved.id);
                        if (index >= 0) {
                            ctrl.items[index] = saved;
                        }
                        toastr.success('Zapisano konfigurację importu leadów');
                    });
            };

            ctrl.statusText = statusText;
            ctrl.statusClass = statusClass;
            ctrl.durationText = durationText;
        }
    })
    .controller('LeadIntegrationAutoImportConfigEditController', function ($uibModalInstance, data, LeadIntegrationAutoImportConfig) {
        this.item = data;
        this.statusText = statusText;
        this.statusClass = statusClass;
        this.durationText = durationText;
        this.cancel = () => $uibModalInstance.dismiss('Canceled');
        this.save = () => LeadIntegrationAutoImportConfig.update({id: this.item.id}, this.item).$promise
            .then(saved => $uibModalInstance.close(saved));
    })
    .service('LeadService', function ($rootScope, toastr, modals, Lead, Principal, PropertyDealService) {
        this.edit = id => {
            return Lead.get({id: id}).$promise.then(item => edit_modal(item));
        };
        this.add = () => {
            let entity = {
                id: null,
                state: {
                    status: "WAIT"
                }
            };
            return edit_modal(entity);
        };
        this.addSuggest = (data, suggestion) => {
            let entity = {
                id: null,
                state: {
                    status: "WAIT"
                }
            };
            angular.extend(entity, data);
            return edit_modal(entity, suggestion);
        };
        this.show = id => {
            Lead.get({id: id}).$promise.then(item => modals.open('app/lead/show-modal.html', 'LeadShowModalController', item, {size: "lg"}, "$ctrl"));
        };
        this.delete = item => {
            return modals.confirmDelete("wybrany rekord", () => Lead.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast('lead.deleted')));
        };
        this.changeManager = item => {
            return modals.open('app/lead/manager-change-modal.html', 'LeadManagerChangeController', item, {size: "sm"}, "$ctrl")
                .then(() => {
                    $rootScope.$broadcast('lead.updated');
                    $rootScope.$broadcast('document.comments.reload', item.id);
                    toastr.success("Zmieniono opiekuna leada");
                });
        };
        this.import = () => modals.open('app/lead/import.html', 'LeadImportController', {}, {size: 'lg'});

        this.isLeadOpen = item => {
            return item.state.status && item.state.status !== 'OUT';
        }
        this.createReservation = item => {
            if (!item.client) {
                toastr.error('Lead bez powiązanego klienta nie może zostać użyty do rezerwacji');
                return;
            }
            let buyer = {
                client: item.client,
                fullName: item.client.fullName,
                email: firstContactValue(item.client, 'EMAIL'),
                phone1: contactValues(item.client, 'PHONE')[0] || null,
                phone2: contactValues(item.client, 'PHONE')[1] || null,
                type: item.client.type,
                nip: item.client.nip,
                address: item.client.address,
                postcode: item.client.postcode,
                city: item.client.city
            }
            let reservationDraft = {
                leadId: item.id,
                buyers: [buyer],
                manager: item.managers.length === 1 ? item.managers[0] : null,
                project: item.projects.length === 1 ? item.projects[0] : null
            }
            return PropertyDealService.add(reservationDraft)
        }

        function firstContactValue(client, type) {
            return contactValues(client, type)[0] || null
        }

        function contactValues(client, type) {
            return ((client && client.contacts) || [])
                .filter(contact => contact && contact.type === type && contact.value)
                .map(contact => contact.value)
        }

        this.linkPropertyDeal = lead => {
            PropertyDealService.leadLink(lead.id).then(propertyDealId => lead.propertyDealId = propertyDealId)
        }
        this.unlinkPropertyDeal = lead => {
            PropertyDealService.leadUnlink(lead.id, lead.propertyDealId).then(() => lead.propertyDealId = null)
        }
        this.smsUnlock = leadId => {
            return modals.confirm("Czy na pewno chcesz odblokowac?", () => Lead.smsUnlock({id: leadId}).$promise).then(() => {
                $rootScope.$broadcast('lead.updated')
                $rootScope.$broadcast('document.comments.reload')
            })
        }
        this.smsLock = leadId => {
            return modals.confirm("Czy na pewno chcesz zablokowac?", () => Lead.smsLock({id: leadId}).$promise).then(() => {
                $rootScope.$broadcast('lead.updated');
                $rootScope.$broadcast('document.comments.reload')
            })
        }
        function edit_modal(entity, suggestion) {
            return modals.open('app/lead/edit-modal.html', 'LeadDialogController', {entity: entity, suggestion: suggestion}, {size: "lg"}, "$ctrl");
        }
    })
    .controller('LeadManagerChangeController', function ($uibModalInstance, data, Lead) {
        this.item = data;
        this.form = {
            manager: (this.item.managers && this.item.managers.length > 0) ? this.item.managers[0] : null,
            comment: ''
        };
        this.users = [];

        this.$onInit = () => Lead.managerCandidates({leadId: this.item.id}).$promise.then(items => this.users = items || []);

        this.cancel = () => $uibModalInstance.dismiss('Canceled');
        this.save = () => {
            return Lead.managerChange({id: this.item.id}, this.form).$promise
                .then(() => $uibModalInstance.close());
        };
    })

    .run(function (NavbarLeftMenu, Principal, $http, $interval, $rootScope) {
        const menuPath = '/lead';

        function loadCounter() {
            Principal.identity().then(() => {
                let auth = Principal.hasAnyAuthority(['ROLE_LEADS']);
                if (!auth) {
                    NavbarLeftMenu.updateCount(menuPath, 0);
                    return;
                }

                $http.get('/crm/api/lead/table-statistics').then(response => {
                    NavbarLeftMenu.updateCount(menuPath, response.data.assignedActionRequiredCount);
                }).catch(() => {
                    NavbarLeftMenu.updateCount(menuPath, 0);
                });
            });
        }

        NavbarLeftMenu.add({
            authorities: "ROLE_LEADS",
            path: menuPath,
            ico: "fa fa-fw fa-users",
            name: 'lead.menu',
            order: 32
        });

        $rootScope.$on('lead.updated', () => loadCounter());
        $rootScope.$on('lead.deleted', () => loadCounter());
        $rootScope.$on('lead.activity.updated', () => loadCounter());
        $rootScope.$on('authenticationChanged', () => loadCounter());

        let intPromise = null;

        function initAutoRefresh() {
            $interval.cancel(intPromise);
            loadCounter();
            intPromise = $interval(initAutoRefresh, 60000);
        }

        this.$onDestroy = () => $interval.cancel(intPromise);

        initAutoRefresh();
    })
    .config(function ($stateProvider) {
        $stateProvider.state('leadList', {
            parent: 'app',
            url: '/lead?{page:int}&{size:int}&sort&search&periodStart&periodEnd&nextContactDateStart&nextContactDateEnd&{acquisitionSource:int}&externalSourceSystem&status&manager&managerMissing&filter&project&tag&createdStart&createdEnd&customFilter',
            data: {
                authorities: ['ROLE_LEADS']
            },
            params: {
                status: {array: true, value: ['WAIT', 'START', 'PROSPECT', 'IN', 'NOD'], squash: false},
                project: {array: true, type: 'int'},
                manager: {type: 'int'},
                filter: {value: 'my', squash: true},
            },
            views: {
                'content@': 'leadList'
            },
            resolve: {
                statistics: (Lead, Principal, $q, $stateParams) => $q.when(normalizeLeadListParams($stateParams, Principal))
                    .then(params => Lead.tableStatistics(params).$promise),
                filters: (Principal, $q, $stateParams) => $q.when(normalizeLeadListParams($stateParams, Principal)),
                page: (Lead, Principal, $q, $stateParams) => $q.when(normalizeLeadListParams($stateParams, Principal))
                    .then(params => Lead.table(params).$promise)
            }
        });
        $stateProvider.state('leadShow', {
            parent: 'app',
            url: '/lead/{id}',
            data: {
                authorities: ['ROLE_LEADS']
            },
            views: {
                'content@': {
                    templateUrl: 'app/lead/show.html',
                    controller: 'LeadShowModalController',
                    controllerAs: '$ctrl'
                }
            },
            resolve: {
                data: (Lead, $stateParams) => Lead.get({id: $stateParams.id}).$promise,
                '$uibModalInstance': $window => ({
                    close: () => $window.history.back(),
                    dismiss: () => $window.history.back()
                })
            }
        });
        $stateProvider.state('leadSalesManagerConfigList', {
            parent: 'app',
            url: '/lead/sales-managers',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_LEADS_SETTINGS']
            },
            views: {
                'content@': 'leadSalesManagerConfigList'
            },
            resolve: {
                items: LeadSalesManagerConfig => LeadSalesManagerConfig.list().$promise
            }
        });
        $stateProvider.state('leadIntegrationAutoImportConfigList', {
            parent: 'app',
            url: '/lead/integration-auto-import-config',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_LEADS_SETTINGS']
            },
            views: {
                'content@': 'leadIntegrationAutoImportConfigList'
            },
            resolve: {
                items: LeadIntegrationAutoImportConfig => LeadIntegrationAutoImportConfig.list().$promise
            }
        });
        function normalizeLeadListParams($stateParams, Principal) {
            const params = angular.copy($stateParams);
            const filter = params.filter || 'my';
            if (params.manager === '') {
                delete params.manager;
            }
            if (params.managerMissing === '' || params.managerMissing === false || params.managerMissing === 'false') {
                delete params.managerMissing;
            }
            if (params.managerMissing === true || params.managerMissing === 'true') {
                delete params.manager;
            }
            if (filter === 'all') {
                delete params.managerMissing;
                return params;
            }
            if (filter === 'unassigned') {
                delete params.manager;
                params.managerMissing = true;
                return params;
            }
            if (filter !== 'my' || params.manager || params.managerMissing) {
                return params;
            }
            return Principal.currentUser().then(user => {
                if (user && user.id) {
                    params.manager = user.id;
                    delete params.managerMissing;
                }
                return params;
            });
        }
    });

function statusText(item) {
    if (!item.lastRunStatus) {
        return 'brak uruchomień';
    }
    if (item.lastRunStatus === 'SUCCESS') {
        return 'OK';
    }
    if (item.lastRunStatus === 'ERROR') {
        return 'Błąd';
    }
    if (item.lastRunStatus === 'RUNNING') {
        return 'W toku';
    }
    return item.lastRunStatus;
}

function statusClass(item) {
    if (item.lastRunStatus === 'SUCCESS') {
        return 'label-success';
    }
    if (item.lastRunStatus === 'ERROR') {
        return 'label-danger';
    }
    if (item.lastRunStatus === 'RUNNING') {
        return 'label-warning';
    }
    return 'label-default';
}

function durationText(item) {
    if (item.lastDurationMs == null) {
        return '-';
    }
    if (item.lastDurationMs < 1000) {
        return item.lastDurationMs + ' ms';
    }
    return (item.lastDurationMs / 1000).toFixed(1) + ' s';
}
